export default __webpack_public_path__ + "static/media/banking&finance.cd7c55eb.jpg";